import { Trans } from "@coworker/locales";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { ItemNoAndType } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { useAvailableElevatedStock } from "@coworker/app/src/hooks/useAvailableElevatedStock";
import { useAllSalesLocationsForArticleQuery } from "@coworker/app/src/hooks/Locations/useAllSalesLocationsForArticleQuery";
import tracker from "@coworker/app/src/helpers/tracker";

interface SalesLocationsAndStockProps {
  itemNoAndType: ItemNoAndType;
}

interface HomeBaseLocation {
  isHomeBase?: boolean;
  isHome?: boolean;
  location?: string;
  locationDescription?: string;
  descriptive?: string;
}

function getLocationInfo(location?: string, locationDescription?: string) {
  if (location && locationDescription)
    return `${location} • ${locationDescription}`;
  else if (location) return `${location}`;
  else return "";
}

export const SalesLocationsAndStock = ({
  itemNoAndType,
}: SalesLocationsAndStockProps) => {
  const navigate = useFixaNavigate();
  const fullId = `${itemNoAndType.type}${itemNoAndType.no}`;

  const { available } = useAvailableElevatedStock(fullId);

  const { data: locationsData, isLoading: isLoadingLocations } =
    useAllSalesLocationsForArticleQuery(fullId);

  const homeBase: HomeBaseLocation =
    (!isLoadingLocations &&
      locationsData?.find((l: HomeBaseLocation) => l.isHomeBase || l.isHome)) ||
    {};

  const description = !["", 0].includes(available)
    ? getLocationInfo(
        homeBase.location,
        homeBase.locationDescription || homeBase.descriptive
      )
    : undefined;

  return (
    <FixaListViewItem
      id="sales-locations-and-stock"
      title={<Trans>salesLocationsAndStockString</Trans>}
      description={description}
      inset
      control="navigational"
      controlIcon={"chevronRight"}
      emphasised
      onClick={() => {
        tracker.trackGlobalActionClick("stock");
        navigate(`/product/${fullId}/stock`);
      }}
    />
  );
};
